import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withFirestore } from 'react-redux-firebase';

const styles = theme => ({
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    padding: '30px',
    [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
      width: '100%',
      maxWidth: 1000,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  paper: {
    marginBottom: theme.spacing.unit * 3,
    padding: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
      marginBottom: theme.spacing.unit * 6,
      padding: theme.spacing.unit * 3
    }
  },
  proposalHeaderContainer: {},
  proposalHeader: {
    cursor: 'pointer',
    display: 'inline-block',
    marginRight: '40px',
    fontWeight: '400',
    '&:hover': {
      color: '#22c26e'
    }
  },
  proposalHeaderSelected: {
    borderBottom: '3px solid #22c26e',
    color: '#22c26e'
  },
  reviewProposalsContentContainer: {
    width: '100%'
  }
});

const mapStateToProps = (state, ownProps) => {
  return {};
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

export default compose(
  withRouter,
  withFirestore,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withStyles(styles)
);



// WEBPACK FOOTER //
// ./src/components/campaign/deals/CampaignDeals.enhancer.js